import React, { useState, useContext } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';
import { useForm, Resolver } from "react-hook-form"
import API from '../API'
import { AdminDeleteEntryType, AdminUpdateEntryType } from '../interfaces';
import { getDayOfWeekName, lookupNameFromObjectsArray } from '../global'
import { SaveDayResponse, ReportingData, ReportingDataDay, DeleteDayResponse, QueryTimeReportRows, AdminPersonMonthReport } from '../../../backend/src/api/dto';

type FormValues = {
    hours: string
    activityId: string
}




function AdminEditDayEntry({ item, day, hours, activities, currentData, updateEntry, deleteEntry }: {
    item: QueryTimeReportRows,
    day: ReportingDataDay,
    hours: {
        hours: number | null, activityId: number
    },
    activities: Array<any>
    currentData: AdminPersonMonthReport,
    updateEntry: AdminUpdateEntryType,
    deleteEntry: AdminDeleteEntryType
}) {

    const [showModal, closeModal] = useContext(ModalContext);
    const { register, handleSubmit, getValues } = useForm<FormValues>({
        defaultValues: {
            hours: (hours.hours ? String(hours.hours) : ""),
        }
    })

    const [loading, setLoading] = useState(false);
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)

    const modalButtons = [
        {
            text: 'Confirm',
            icon: 'check',
            onClick: () => onSubmit(),

            style: 'primary'
        }, {
            text: 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    const onSubmit = () => {
        const form = getValues();


        setLoading(true);
        return new Promise((resolve, reject) => {
            handleSubmit((data) => {
                console.log({ data: getValues() })

                const hoursValue = parseInt(data.hours);
                if (Number.isInteger(hoursValue)) {
                    API.setDay(item.timeReportRowId, day.day, hoursValue, hours.activityId ?? 0).then((data2: SaveDayResponse) => {
                        setLoading(false);
                        setApiResult({
                            status: true,
                        })
                        updateEntry(data2.day, data2.timeReportRowId, data2.hours, data2.timeReportEntryId, hours.activityId)
                        closeModal(null);
                        resolve(1)
                    }).catch((e) => {
                        console.log("--- 1", e)
                        setLoading(false);
                        setApiResult(e)
                        resolve(1)
                    })
                } else {
                    API.deleteDay(item.timeReportRowId, day.day, hours.activityId ?? 0).then((data2: DeleteDayResponse) => {
                        setLoading(false);
                        setApiResult({
                            status: true,
                        })
                        deleteEntry(data2.day, data2.timeReportRowId, hours.activityId)
                        closeModal(null);
                        resolve(1)
                    }).catch((e) => {
                        setLoading(false);
                        setApiResult(e)
                        resolve(1)
                    })
                }
            })()
        })

    }



    return (



        <Modal
            buttons={modalButtons}
            title={'Upraviť jeden záznam'}
            errorObject={apiResult}
            disableAllButtons={loading}
        >
            <form onSubmit={onSubmit}>




                <div className="row mb-2">
                    <div className="col-5 text-end mt-1">
                        Hodiny
                    </div>
                    <div className="col-3">
                        <div className="input-group">
                            <input autoFocus  {...register("hours")} className="form-control form-control-sm" />
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-5 text-end">
                        Den
                    </div>
                    <div className="col-7">
                        <strong>{day.day}</strong>.{currentData.month}.{currentData.year}
                        &nbsp;&nbsp;
                        <small className="text-muted">{getDayOfWeekName(day.dayOfWeek)}</small>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-5 text-end">
                        Projekt
                    </div>
                    <div className="col-7">
                        {item.projectName}
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-5 text-end">
                        Zakazka
                    </div>
                    <div className="col-7">
                        {item.orderName}
                    </div>
                </div>



                {
                    item.withActivities ?

                        <div className="row mb-2">
                            <div className="col-5 text-end">
                                Aktivita
                            </div>
                            <div className="col-7">{
                                lookupNameFromObjectsArray(activities, 'activityId', hours.activityId ?? 0)
                            }</div>
                        </div>
                        :
                        null
                }


            </form>
        </Modal>


    )

}

export default AdminEditDayEntry
